export default "__VITE_ASSET__b6681472__"